import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss'],
})
export class DynamicTableComponent implements OnChanges, OnInit {
  // Define columns dynamically
  @Input() displayedColumns: { key: string;label: string;sublabel?:string}[] = [];

  // Get the keys for the table (derived from displayedColumns)
  displayedColumnsKeys: string[] = [];

  // Define table data
  @Input() dataSource = new MatTableDataSource([]);

  constructor() { }

  ngOnInit(): void {
    this.displayedColumnsKeys = this.displayedColumns.map((col) => col.key);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update displayedColumnsKeys whenever displayedColumns changes
    if (changes['displayedColumns']?.currentValue) {
      this.displayedColumnsKeys = this.displayedColumns.map((col) => col.key);
    }
  }
}
